<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div box">
      <div class="list-header-title-div">商品列表</div>
      <div class="page-action-btns">
        <div>
          <el-button type="primary" @click="handelAdd">
            发布商品
          </el-button>
          <el-button type="primary" @click="handelUpShop">
            上架
          </el-button>
          <el-button type="primary" @click="handelDownShop">
            下架
          </el-button>
          <el-button type="primary" @click="handelExport">
            导出
          </el-button>
        </div>

        <div>
          <el-input
            v-model="form.search"
            placeholder="请输入搜索内容"
            style="margin-right:20px"
            clear
          ></el-input>
          <el-button type="primary" @click="handelSearch">
            搜索
          </el-button>
        </div>
      </div>
      <!-- 表格 -->

      <div class="shop-box">
        <template>
          <el-table
            :data="tableData"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>

            <el-table-column
              prop="shelvesDisplayPictureUrl"
              label="商品名称"
              width="230px"
              align="center"
            >
              <template slot-scope="scope">
                <el-image
                  style="width: 223px; height: 137px;border-radius: 8px;"
                  :src="scope.row.shelvesDisplayPictureUrl"
                  @click.native.stop
                  :preview-src-list="[scope.row.shelvesDisplayPictureUrl]"
                >
                </el-image>
              </template>
            </el-table-column>
            <el-table-column
              prop="commodityName"
              label="商品名称"
              min-width="110"
              align="center"
            >
            </el-table-column>

            <el-table-column
              prop="commodityNo"
              label="商品编码"
              min-width="110"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="commodityCategory"
              label="商品类别"
              min-width="110"
              align="center"
            >
              <template slot-scope="scope">
                <p>
                  {{
                    scope.row.commodityCategory == '01'
                      ? '充电桩'
                      : scope.row.commodityCategory == '02'
                      ? '配件'
                      : scope.row.commodityCategory == '03'
                      ? '服务'
                      : ''
                  }}
                </p>
              </template>
            </el-table-column>
            <el-table-column
              prop="commodityPrice"
              label="商品价格"
              min-width="110"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="visits"
              label="访问量"
              min-width="110"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="salesVolume"
              label="销量"
              min-width="110"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="commodityType"
              label="状态"
              min-width="110"
              align="center"
            >
              <template slot-scope="scope">
                <p>
                  {{
                    scope.row.commodityType == '01'
                      ? '上架中'
                      : scope.row.commodityType == '02'
                      ? '已下架'
                      : scope.row.commodityType == '03'
                      ? '待上架'
                      : ''
                  }}
                </p>
              </template>
            </el-table-column>
            <el-table-column
              prop="createdByName"
              label="创建人"
              min-width="110"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="createdWhen"
              label="创建时间"
              min-width="160"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop=""
              fixed="right"
              label="操作"
              width="150"
              align="center"
            >
              <template slot-scope="scope">
                <div class="flex-x">
                  <p @click.stop="handelEdit(scope.row.commodityId)">编辑</p>
                  <p @click.stop="handelRowDown(scope.row.commodityId)">下架</p>
                  <p @click.stop="handelDetial(scope.row.commodityId)">详情</p>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>

      <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        ></ZD-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  name: '',
  components: {},
  props: {},
  data() {
    return {
      pageConfig: pageConfig, 
      pagination: pageConfig.pagination,//页码
      checklist: [],  //选中表单

      form: {},  //搜索框内容
      info: {},  //搜索内容与页码
      tableData: [],    //表单数据
    }
  },
  computed: {},
  watch: {},
  created() {
    this.init()
  },
  mounted() {},
  methods: {
      //选中表单
    handleSelectionChange(val) {
      this.checklist = val
    },
    //新增
    handelAdd() {
      this.$store.commit('setEditId')
      this.$router.push({
        name: 'commodityDetial',
      })
    },
    //搜索
    handelSearch() {
      this.info.commodityName = this.form.search
      this.getListData(this.pageConfig.pagination)
    },
    //上架
    handelUpShop() {
      if (this.checklist.length == '0') {
        this.$U.confirmSure(this, '请选择操作对象')
      } else {
        this.$U.confirmT(
          this,
          '是否确定上架?',
          '上架后用户可以在商品列表查看商品',
          () => {
            let _ = this
            let commodityQuery = {}
            commodityQuery.ids = []
            _.checklist.forEach((item) => {
              commodityQuery.ids.push(item.commodityId)
            })

            _.$H.post(_, _.$A.commodity.up, commodityQuery).then((res) => {
              if (res.data.data) {
                _.$U.confirmSure(_, '成功', () => {
                  _.init()
                })
              }
            })
          }
        )
      }
    },
    // 下架
    handelDownShop() {
      if (this.checklist.length == '0') {
        this.$U.confirmSure(this, '请选择操作对象')
      } else {
        this.$U.confirmT(
          this,
          '是否确定下架?',
          '下架后用户将无法在商品列表中查看到该商品，未支付的订单也将无法下单',
          () => {
            let _ = this
            let commodityQuery = {}
            commodityQuery.ids = []
            _.checklist.forEach((item) => {
              commodityQuery.ids.push(item.commodityId)
            })
            _.$H.post(_, _.$A.commodity.down, commodityQuery).then((res) => {
              if (res.data.data) {
                _.$U.confirmSure(_, '下架成功', () => {
                  _.init()
                })
              }
            })
          }
        )
      }
    },
    //     表单内下架按钮
    handelRowDown(e) {
      this.$U.confirmT(
        this,
        '是否确定下架?',
        '下架后用户将无法在商品列表中查看到该商品，未支付的订单也将无法下单',
        () => {
          let _ = this

          _.$U.showLoading(_)
          let commodityQuery = {}
          commodityQuery.ids = []

          commodityQuery.ids.push(e)

          _.$H.post(_, _.$A.commodity.down, commodityQuery).then((res) => {
            _.$U.hideLoading(_)
            _.$U.confirmSure(_, '下架成功', () => {
              _.init()
            })
          })
        }
      )
    },
    //下载
    handelExport() {
      let _ = this
      _.$U.showLoading(_)
      let obj = {}
      obj.commodityName = _.form.search
      _.$H.post(_, _.$A.commodity.export, obj).then((res) => {
        _.$U.hideLoading(_)
        window.open(res.data.data.url)
      })
    },
    //编辑
    handelEdit(e) {
      // let id = e.id;
      this.$store.commit('setEditId', e)
      this.$router.push({
        name: 'commodityDetial',
      })
    },
      //详情
    handelDetial(e) {

      this.$store.commit('setEditId', e)
      let obj = {}
      obj.detialDisbale = true
      this.$router.push({
        name: 'commodityDetial',
        params: obj,
      })
    },
    init() {
      this.getListData(this.pageConfig.pagination)
    },
    //获取表单数据
    getListData(val) {
      this.info.pageNum = val.current - 1
      this.info.pageSize = val.pageSize

      let _ = this
      _.$H.get(_, _.$A.commodity.list, _.info).then((res) => {
        _.tableData = res.data.data.content || []
        _.pageConfig.pagination.total = res.data.data.totalElements || 0
      })
    },
  },
}
</script>

<style scoped lang="less">
.list-container .list-content-div {
  .page-action-btns {
    width: 100%;
    margin: 20px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    div {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .el-button--default {
      width: 128px;
      height: 40px;
      border: 1px solid #bb87f3;
      border-radius: 5px;
      background-color: #fff;
      color: #bb87f3;
    }
    .el-button--primary {
      width: 128px;
      height: 40px;
    }
  }
  .flex-x {
    color: #bb87f3;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }
  .shop-box {
    margin-top: 38px;
  }
}
</style>
